/* istanbul ignore file */

import { MenuItem } from './Menu.tsx';
import { IconArrowBarToLeft } from '@tabler/icons-react';
// import debug from 'debug';

// const log = debug('MenuUsuario');
export const MenuItemsUsuario: MenuItem[] = [
    {
        label: 'ESTADÍSTICAS',
        icon: 'stats-up',
        url: '/estadisticas',
    },
    {
        //TODO: hay que hacer que se active uno u otro segun flag, por ahora dejo en duro el viejo
        label: 'CONFIGURACION',
        icon: 'panel',
        legacyUrl: '/settings',
    },
    // {
    //     label: 'CONFIGURACION NUEVA',
    //     icon: 'panel',
    //     url: '/configuracion',
    // },
    // {
    //     label: 'PERFIL',
    //     icon: iconPanel,
    //     url: '/perfil',
    // },
    {
        label: 'FACTURACION',
        icon: 'credit-card',
        url: '/facturacion',
    },
    {
        label: 'MANUAL',
        newTab: 'https://luker.supporthero.io/',
        icon: 'help',
    },
    {
        label: 'SALIR',
        icon: <IconArrowBarToLeft />,
        url: '/logout',
    },
];
